__webpack_require__.p = "https://cdn.miniapps.nmbbank.co.tz/superapp-console-fe/0.1.4/";